import { DEFAULT_TARGET } from "@constants";
import { useAppStore } from "@store/appStore";
import { useShareLocation } from "@store/shareLocationStore";
import { EMessageActionType, IButton, IMessageAction } from "@types";
import { createDataAttr } from "@utils";
import { shallow } from "zustand/shallow";
import { resolveOptionsLayout } from "./richMessageLayout";
interface IOptionMessageProps {
  message: IButton;
  linkTarget?: string;
  onSendAction: (action: IMessageAction) => void;
}

interface IButtonActionProps {
  button: IMessageAction;
  linkTarget?: string;
  onSendAction: (action: IMessageAction) => void;
}

const DEFAULT_CLASSNAME =
  "inline-flex cursor-pointer items-center justify-center py-4 text-center text-blue-700 break-all";

const ButtonAction = ({
  button,
  linkTarget = DEFAULT_TARGET,
  onSendAction,
}: IButtonActionProps) => {
  const { settings } = useAppStore(
    (state) => ({
      settings: state.settings,
    }),
    shallow,
  );
  const optionLayout = resolveOptionsLayout(settings.richMessage);
  const { setIsOpen } = useShareLocation((state) => {
    return state;
  }, shallow);
  if (
    button.type === EMessageActionType.DATE_TIME_PICKER ||
    button.type === EMessageActionType.CAMERA_ACTION
  ) {
    <button className={DEFAULT_CLASSNAME} style={optionLayout.buttonStyle}>
      {button.label}
    </button>;
  }
  // link action
  if (button.type === EMessageActionType.URI_ACTION) {
    return (
      <a
        className={DEFAULT_CLASSNAME}
        href={button.uri}
        style={optionLayout.buttonStyle}
        target={linkTarget}
      >
        {button.label}
      </a>
    );
  }
  // call action
  if (button.type === EMessageActionType.CALL_ACTION) {
    return (
      <a
        className={DEFAULT_CLASSNAME}
        href={`tel:${button.phoneNo}`}
        style={optionLayout.buttonStyle}
      >
        {button.label}
      </a>
    );
  }
  // location action
  if (button.type === EMessageActionType.LOCATION_ACTION) {
    if (settings.allowLocation === false) {
      return null;
    }
    return (
      <button
        className={DEFAULT_CLASSNAME}
        onClick={() => setIsOpen(true)}
        style={optionLayout.buttonStyle}
      >
        {button.label}
      </button>
    );
  }
  return (
    <button
      className={DEFAULT_CLASSNAME}
      onClick={() => onSendAction(button)}
      style={optionLayout.buttonStyle}
    >
      {button.label}
    </button>
  );
};

export const OptionsMessage = ({
  message,
  linkTarget = DEFAULT_TARGET,
  onSendAction,
}: IOptionMessageProps) => {
  const { settings } = useAppStore(
    (state) => ({
      settings: state.settings,
    }),
    shallow,
  );
  const optionLayout = resolveOptionsLayout(settings.richMessage);
  const showDefaultDivider =
    !settings.richMessage?.buttons?.buttonStyle?.borderBottom;
  const actions =
    settings.allowLocation === false
      ? message.actions?.filter(
          (button: IMessageAction) =>
            button.type !== EMessageActionType.LOCATION_ACTION,
        )
      : message.actions;

  return (
    <div className="flex items-center" {...createDataAttr("option-message")}>
      <div
        className="w-full rounded-lg bg-white p-3"
        style={optionLayout.containerStyle}
      >
        <p className="mb-4 whitespace-pre-wrap break-words text-gray-600">
          {message.text}
        </p>
        <hr className="border-t" />
        <div>
          {actions &&
            actions.map((button: IMessageAction, index: number) => (
              <div
                className="mx-auto flex flex-col"
                key={button.id}
                {...createDataAttr("option-button")}
              >
                <ButtonAction
                  button={button}
                  onSendAction={onSendAction}
                  linkTarget={linkTarget}
                />
                {showDefaultDivider && index !== actions.length - 1 && (
                  <hr className="my-2 border-t" />
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
